export const HEADER_TITLE = "Change flight";
export const HEADER_SUBTITLE = "Make a change to your flight";

export const BACK_TO_MY_TRIPS = "Back to My trips";
export const GO_BACK = "Go back";

export const FLIGHT_DATES_SESSION_STORAGE_KEY = "chfarFlightDates";
export const FLIGHT_ROUTE_SESSION_STORAGE_KEY = "chfarFlightRoute";
